import { NgModule } from '@angular/core';
import { GridComponent } from './components/grid/grid.component';
import { MaterialModule } from './modules/material.module';
import { GridPaginatorComponent } from './components/grid/grid-paginator/grid-paginator.component';
import { GridSkeletonComponent } from './components/grid/grid-skeleton/grid-skeleton.component';
import { GridBodyColumnComponent } from './components/grid/grid-body-column/grid-body-column.component';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './components/layout/layout.component';
import { MenuComponent } from './components/layout/menu/menu.component';
import { RouterModule } from '@angular/router';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { FormControlComponent } from "./components/form-control/form-control.component";
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AlertComponent } from './components/alert/alert.component';
import { AlertService } from './services/alert.service';
import { ModalContainerComponent } from './components/modal-container/modal-container.component';
import { DialogService } from './services/dialog.service';
import { FieldsetComponent } from './components/fieldset/fieldset.component';
import { SearchFormButtonsComponent } from './components/buttons/search-form-buttons/search-form-buttons.component';
import { ToastService } from './services/toast.service';
import { ToolbarGridComponent } from './components/toolbar-grid/toolbar-grid.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { TemplateDirective } from './directives/template.directive';
import { NumberOnlyDirective } from './directives/number-only.directive';
import { DisableControlDirective } from './directives/disabled-control.directive';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { TextLimitPipe } from './pipes/text-limit.pipe';
import { LoaderConfigurationComponent } from './components/loader-configuration/loader-configuration.component';
import { IconLabelComponent } from './components/icon-label/icon-label.component';
import { FormSearchContainerComponent } from './components/form-search-container/form-search-container.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { ModalVerArchivoComponent } from './components/modal-ver-archivo/modal-ver-archivo.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { PageLoaderComponent } from './components/page-loader/page-loader.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NumberThousandPipe } from './pipes/number-thousand.pipe';
import { ErrorComponent } from './components/error/error.component';
import { DragDropModule } from '@angular/cdk/drag-drop';

const COMPONENTS_DECLARATIONS = [
  GridComponent,
  GridBodyColumnComponent,
  GridPaginatorComponent,
  GridSkeletonComponent,
  LayoutComponent,
  PageTitleComponent,
  FormControlComponent,
  MenuComponent,
  AlertComponent,
  ModalContainerComponent,
  FieldsetComponent,
  SearchFormButtonsComponent,
  ToolbarGridComponent,
  ProgressBarComponent,
  BreadcrumbComponent,
  LoaderConfigurationComponent,
  IconLabelComponent,
  FormSearchContainerComponent,
  FileUploadComponent,
  ModalVerArchivoComponent,
  PaginatorComponent,
  PageLoaderComponent,
  ErrorComponent
];

const DIRECTIVES_DECLARATIONS = [
  TemplateDirective,
  NumberOnlyDirective,
  DisableControlDirective
];

const PIPES_DECLARATIONS = [
  DateFormatPipe,
  TextLimitPipe,
  NumberThousandPipe
];

const COMPONENTS_EXPORTS = [
  GridComponent,
  LayoutComponent,
  PageTitleComponent,
  FormControlComponent,
  ModalContainerComponent,
  FieldsetComponent,
  SearchFormButtonsComponent,
  ToolbarGridComponent,
  ProgressBarComponent,
  BreadcrumbComponent,
  LoaderConfigurationComponent,
  IconLabelComponent,
  FormSearchContainerComponent,
  FileUploadComponent,
  ModalVerArchivoComponent,
  FlexLayoutModule,
  PaginatorComponent,
  PageLoaderComponent,
  ErrorComponent
];

const DIRECTIVES_EXPORTS = [
  TemplateDirective,
  NumberOnlyDirective,
  DisableControlDirective
];



@NgModule({
  declarations: [
    ...COMPONENTS_DECLARATIONS,
    ...DIRECTIVES_DECLARATIONS,
    ...PIPES_DECLARATIONS,
  ],
  imports: [
    MaterialModule,
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxMaterialTimepickerModule,
    FlexLayoutModule,
    NgxSliderModule,
    DragDropModule
  ],
  exports: [
    ...COMPONENTS_EXPORTS,
    ...DIRECTIVES_EXPORTS,
    ...PIPES_DECLARATIONS,
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    NgxMaterialTimepickerModule,
    NgxSliderModule
  ],
  providers: [
    AlertService,
    DialogService,
    ToastService
  ],
  entryComponents: [
    AlertComponent
  ]
})
export class SharedModule { }
